// src/routes/RouteSetup.tsx
import React from "react";
import { Routes, Route } from "react-router-dom";

// Layouts
import LayoutWithHeader from "./LayoutWithHeader";
import LayoutWithHeaderAndNav from "./LayoutWithHeaderAndNav";
import CareerAcceleratorLayout from "./PartnerRoutes/CareerAccelerator/CareerAcceleratorLayout";
import SeeULayout from "./PartnerRoutes/SeeU/SeeULayout";

// Public Pages
import LoginPage from "../pages/LoginPage";
import PrivacyPage from "../pages/PrivacyPage";
import TermsAndConditionsPage from "../pages/TermsNConditionPage";
import OAuthCallback from "../pages/OAuthCallbackPage";

// Main Site Pages (with header)
import HomePage from "../pages/HomePage";
import MockCasePage from "../pages/MockCasePage";
import ReportPage from "../pages/ReportPage/ReportPage";
// import CaseReportsPage from "../pages/CaseReportsPage";
import CaseSelectionPage from "../pages/CaseSelectionPage";
// import InterviewHistoryPage from "../pages/InterviewHistoryPage";
import FeedbackPage from "../pages/FeedbackPage";

// Other Pages
import SurveyPage from "../pages/SurveyPage";

// Business Pages
import PartnerLoginPage from "./PartnerRoutes/PartnerLoginPage";

// Protected Route wrapper
import ProtectedRoute from "./ProtectedRoute";
import RedirectPage from "../pages/RedirectPage.tsx";
import TutorialPage from "../pages/MockCasePage/Tutorial/TutorialPage";
import SubscriptionPage from "../pages/SubscriptionPage";
import WeeklyContestPage from "../pages/WeeklyContestPage";
import CheckoutPage from "../pages/CheckoutPage";
import AssessmentHistoryPage from "../pages/AssessmentHistoryPage";
import UCLAbsnLayout from "./PartnerRoutes/UCLAbsn/UCLAbsnLayout";
import BabsonBcaLayout from "./PartnerRoutes/BabsonBca/BabsonBcaLayout";

// Reusable partner routes fragment
const partnerRoutes = (
  <>
    {/* Routes with both header and navigation */}
    <Route element={<LayoutWithHeaderAndNav />}>
      <Route element={<ProtectedRoute />}>
        <Route index element={<HomePage />} />
        {/* <Route path="case-reports" element={<CaseReportsPage />} /> */}
        <Route path="interviews" element={<CaseSelectionPage />} />
        {/* <Route
                    path="interview-history"
                    element={<InterviewHistoryPage />}
                /> */}
        <Route path="assessment-history" element={<AssessmentHistoryPage />} />
        <Route path="weekly-contest" element={<WeeklyContestPage />} />
      </Route>
    </Route>

    {/* Routes with header only */}
    <Route path="login" element={<PartnerLoginPage />} />

    <Route element={<LayoutWithHeader />}>
      <Route path="survey" element={<SurveyPage />} />
      <Route path="redirect" element={<RedirectPage />} />
      <Route path="privacy" element={<PrivacyPage />} />
      <Route path="terms" element={<TermsAndConditionsPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="mock-case" element={<MockCasePage />} />
        <Route path="report" element={<ReportPage />} />
        <Route path="mock-case-tutorial" element={<TutorialPage />} />
        <Route path="checkout" element={<CheckoutPage />} />
        <Route path="feedback/:title" element={<FeedbackPage />} />
      </Route>
      <Route path="case-selection" element={<CaseSelectionPage />} />
    </Route>
  </>
);

const RouteSetup: React.FC = () => {
  return (
    <Routes>
      {/* Routes with both header and navigation */}
      <Route element={<LayoutWithHeaderAndNav />}>
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/case-reports" element={<CaseReportsPage />} /> */}
          <Route path="/interviews" element={<CaseSelectionPage />} />
          {/* <Route
                        path="/interview-history"
                        element={<InterviewHistoryPage />}
                    /> */}
          <Route
            path="/assessment-history"
            element={<AssessmentHistoryPage />}
          />
          <Route path="/weekly-contest" element={<WeeklyContestPage />} />
        </Route>
      </Route>

      {/* Routes with header only */}
      <Route element={<LayoutWithHeader />}>
        <Route path="/redirect" element={<RedirectPage />} />

        {/* Protected main site routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/mock-case" element={<MockCasePage />} />
          <Route path="/report" element={<ReportPage />} />
          <Route path="/mock-case-tutorial" element={<TutorialPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/feedback/:title" element={<FeedbackPage />} />
        </Route>
        <Route path="/subscription" element={<SubscriptionPage />} />
        <Route path="/weekly-contest" element={<WeeklyContestPage />} />
        <Route path="/case-selection" element={<CaseSelectionPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsAndConditionsPage />} />
      </Route>

      {/* Protected route without header */}
      <Route element={<ProtectedRoute />}>
        <Route path="/survey" element={<SurveyPage />} />
      </Route>

      {/* Routes without header */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/oauth/callback" element={<OAuthCallback />} />

      {/* Career Accelerator Routes */}
      <Route path="/career-accelerator" element={<CareerAcceleratorLayout />}>
        {partnerRoutes}
      </Route>

      {/* SeeU Routes */}
      <Route path="/seeu" element={<SeeULayout />}>
        {partnerRoutes}
      </Route>

      {/* UCLA BSN Routes */}
      <Route path="/ucla-bsn" element={<UCLAbsnLayout />}>
        {partnerRoutes}
      </Route>

      {/* Babson BCA Routes */}
      <Route path="/babson-bca" element={<BabsonBcaLayout />}>
        {partnerRoutes}
      </Route>
    </Routes>
  );
};

export default RouteSetup;
